/**
 * 잘못된 이메일 형식 입력
 */
 export default class InvalidEmailError extends Error {}